export const POLICY_VERSION = '2026-10-18.1';
export const POLICY_DATE = '2026-10-18';
